<template>
    <div class="row auctionsTab flex-fill">
        <div class="row h-100 text-center d-flex justify-content-center flex-grow-1">
            <div class="col-md-6 auctionTabHolder flex-fill d-flex flex-column">
                <div class="auctionsHeader">
                    <h4 class="title">
                        {{ $t('home.home_auction_title') }}
                        <b-button v-if="currentTab == 0 && user.mtsCustomer" @click="groupfilterToggle()" :variant="filter ? 'secondary' : 'flat'" size="sm">
                            <i class="fas fa-filter"></i>
                        </b-button>
                    </h4>
                    <ul>
                        <li :class="currentTab == 0 ? 'active' : ''">
                            <a @click="tabSet(0)">{{ $t('home.home_auction_tab_all') }}</a>
                        </li>
                        <li :class="currentTab == 1 ? 'active' : ''">
                            <a @click="tabSet(1)">{{ $t('home.home_auction_tab_my') }}</a>
                        </li>
                        <li :class="currentTab == 2 ? 'active' : ''">
                            <a @click="tabSet(2)">{{ $t('home.home_auction_tab_arhive') }}</a>
                        </li>
                    </ul>
                </div>
                <ul v-if="auctions.length > 0" class="auctionsList h-100">
                    <auction-list-item v-for="a in auctions" :auction="a" :currentTab="currentTab" :key="a.id" @updateAuction="onAuctionUpdate"></auction-list-item>
                </ul>
                <div v-else class="d-flex flex-fill p-3">
                    <span class="text-primary m-auto" v-html="$t('home.home_auction_tab_all_no_data')"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../../api'
import io from '../../socketio';
import AuctionListItem from './AuctionListItem.vue';

const AuctionsTab = Vue.component('auctions-tab', {
    components:{
        AuctionListItem
    },

    props: {
        tab: 0
    },
    
    data(){
    	return {
            auctions: [],
            currentTab: -1,
            filter: false,
            page: 1,
            perPage: 100,
    	};
    },
    
    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        tabSet(tab, page = 1, silent = false){
            if(this.currentTab == tab && this.page === page && silent !== true) return;
            if(silent !== true) this.btnSfx();
            
            this.currentTab = tab;
            const $this = this;

            // clear list
            this.auctions = [];

            let req = api.auctionsActive;
            if (tab == 1)
                req = api.auctionsWon;
            else if(tab == 2)
                req = api.auctionsFinished;

            req({
                includeMtsCustomerCategory: this.filter && this.user.mtsCustomer ? this.user.mtsCustomerCategory.name : null,
                page: page,
                count: this.perPage

            }).then(res => {
                $this.auctions = res.data ?? [];
                $this.page = page;
            })
            .catch(err => {
                api.baseErrorHendler(err);
            });
        },

        onAuctionUpdate(data){
            if(!data.id) return;

            let searchIndex = this.auctions.findIndex(x => x.id == data.id);
            if (searchIndex > -1){
                Vue.set(this.auctions, searchIndex, data);
            }
        },

        updateFromRequestPopup(event){
            this.tabSet(this.currentTab, 1, true);
        },

        groupfilterToggle(){
            this.filter = !this.filter;
            this.tabSet(this.currentTab, 1, true)
        }
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
    },

    created(){
        this.tabSet(this.tab, 1, true);
        io.io.on('AUCTION_UPDATE', this.onAuctionUpdate);
        this.$root.$on('updateAuctionRequest', this.updateFromRequestPopup);
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
        io.io.off('AUCTION_UPDATE', this.onAuctionUpdate);
        this.$root.$off('updateAuctionRequest', this.updateFromRequestPopup);
    },

});

export default AuctionsTab
</script>
